import React from 'react';
import { Navigate, Route, Routes,
    //  useLocation, useNavigate
     } from 'react-router-dom';
import { mainPublicRoutesArr } from './mainPublicRoutesArr';
import Storage from '../services/Storage';
import AppFooter from '../Layout/AppFooter';

const MainPublicRoutes = () => {
    const token = Storage.getTokenDetail() || {};
    // const { pathname } = useLocation();
    // const navigate = useNavigate();

    // let publicArrPath = mainPublicRoutesArr.map(item => item.path) || [];

    // if (!token.accessToken && !publicArrPath.includes(pathname)) {
    //     navigate('/user/login');
    //     return null;
    // }

    return (
        <>
            <Routes>
                {mainPublicRoutesArr.map((route, index) => {
                    return (
                        <Route
                            key={index}
                            path={`${route.path}`}
                            element={<route.component />}
                        />
                    );
                })}
                <Route
                    path="/*"
                    element={(!token.accessToken) ? <Navigate to="/user/login" replace /> : <Navigate to="/agrocel/dashboard" />}
                />
            </Routes>
            <AppFooter />
        </>
    )
}

export default MainPublicRoutes
